import { useContext } from 'react';

import { ZBError } from '@zenbusiness/application-commons-logging';

import { ChangeRequest, SetChangeRequest } from '../contexts/ChangeRequestContext';

export function useChangeRequestContext() {
  const context = useContext(ChangeRequest);

  if (typeof context === 'undefined') {
    throw new ZBError('useChangeRequestContext must be used within a ChangeRequestContext.Provider');
  }

  const { changeFlow } = context;
  return { changeFlow };
}

export function useSetChangeRequest() {
  const context = useContext(SetChangeRequest);

  if (typeof context === 'undefined') {
    throw new ZBError('useSetChangeRequest must be used within a SetChangeRequest.Provider');
  }

  const { setChangeFlow } = context;
  return { setChangeFlow };
}
